import React from "react";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import palette from "./palette";
import typography from "./typography";
import components from "./components";

export const baseTheme = createTheme({
  palette,
  typography,
});

const theme = createTheme({
  ...baseTheme,
  components,
});

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
